<div
    class="modal fade show" 
    [ngClass]="{'expanded': !isExpanded}"
    id="cycle-count-upload-detail-modal" 
    tabindex="-1" 
    aria-labelledby="cycle-count-upload-detail-modalLabel" 
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-xl">
        @if (showLoader) {
<app-loader></app-loader>
}
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex w-100">
                    <div class="me-2 id flex-fill">
                        <h4 class="modal-title mb-0 item-id">Cycle Count Upload</h4>
                    </div>
            
                    <div class="btns-header">
                        <button 
                            class="header-icon close p-0 m-0" 
                            (click)="close()" 
                            aria-label="Close"
                        >
                            <i 
                                class="fas fa-times" 
                                title="Close Popup"
                            ></i>
                        </button>
                        <button 
                            class="close header-icon expand-modal p-0 m-0"
                            (click)="expand()"
                        >
                            <i 
                                class="fas ms-2 me-2" 
                                [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}" 
                                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body pt-0">
                <div class="w-100" style="margin-top: 20px;">
                    @if (gridConfig) {
                    <div [style.height.px]="gridHeight">
                        <inavista-grid #cycleCountUploadDetailGrid class="so-popup-grid"
                            [config]="gridConfig"
                            (hyperlinkClick)="showMasterItemCodePopup(lineFor($event.row))"
                            (exportRequested)="onExportRequested()" />
                    </div>
                    }
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-info close-modal" (click)="browseFile.emit()">Browse</button>
                <button type="button" class="btn btn-sm btn-success me-1" (click)="fileUpload()">Upload</button>
            </div>
        </div>
    </div>
</div>
